import {Vector3} from 'three'

import {CORNER_RADIUS} from '../../modules/cube/_config'
const calcPosition = (pos: Vector3) => {
  pos.x *= 1.0 + CORNER_RADIUS * 1.1
  pos.y *= 1.0 + CORNER_RADIUS * 1.1
  pos.z *= 1.0 + CORNER_RADIUS * 1.1

  return pos
}

export default [
  {
    delay: 0.1,
    scale: 1,
    position: {
      def: new Vector3(0, -0.6, 0),
      offset: new Vector3(0, -2, 0),
      current: new Vector3(0, 0, 0),
      duration: 1.5,
      ease: 'expo.out',
    },
    rotation: {
      def: new Vector3(Math.PI * 0.25, -Math.PI * 0.2, 0),
      offset: new Vector3(-Math.PI, 0, 0),
      current: new Vector3(0, 0, 0),
      duration: 2.0,
      ease: 'expo.out',
    },
  },
  {
    delay: 0.1,
    scale: 1.3,
    position: {
      def: new Vector3(0, -0.6, 0),
      offset: new Vector3(0, -2, 0),
      current: new Vector3(0, 0, 0),
      duration: 1.5,
      ease: 'expo.out',
    },
    rotation: {
      def: new Vector3(0, 0, 0),
      offset: new Vector3(-Math.PI, 0, 0),
      current: new Vector3(0, 0, 0),
      duration: 2.0,
      ease: 'expo.out',
    },
  },
  {
    delay: 0.1,
    scale: 1.0,
    position: {
      def: new Vector3(1, -1.5, 1),
      offset: new Vector3(0, -2, 0),
      current: new Vector3(0, 0, 0),
      duration: 1.5,
      ease: 'expo.out',
    },
    rotation: {
      def: new Vector3(0, 0, 0),
      offset: new Vector3(0, Math.PI, 0),
      current: new Vector3(0, 0, 0),
      duration: 2.0,
      ease: 'expo.out',
    },
  },
  {
    delay: 0.1,
    scale: 1,
    position: {
      def: calcPosition(new Vector3(2, -1, -3)),
      offset: new Vector3(0, -2, 0),
      current: new Vector3(0, 0, 0),
      duration: 1.6,
      ease: 'expo.out',
    },
    rotation: {
      def: new Vector3(0, 0, 0),
      offset: new Vector3(0, Math.PI, 0),
      current: new Vector3(0, 0, 0),
      duration: 2.0,
      ease: 'expo.out',
    },
  },
]
